import axios from 'axios'

export function getMobileAppSettings() {
  return axios.get('/Config/MobileAppSettings')
}
